import { authorizedUser } from "components/Common/commonFunctions";
import * as api from "../API/index";
import { availableTechnicianDates } from "constants/availableTechnicianDates";

export const getAvailableDates = async (dispatch, technicianId) => {
  try {
    const res = await api.available_technician_dates_by_ID(technicianId);
    dispatch({
      type: availableTechnicianDates,
      payload: res.data || [],
    });
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const addRescheduleJobById = async (jobId, bodyData) => {
  try {
    const res = await api.reschedule_job_BY_ID(jobId, bodyData);
    return res.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};
